// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import CodeTwoToneSvg from "@ant-design/icons-svg/es/asn/CodeTwoTone";
import AntdIcon from '../components/AntdIcon';

var CodeTwoTone = function CodeTwoTone(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: CodeTwoToneSvg
  }));
};

CodeTwoTone.displayName = 'CodeTwoTone';
export default React.forwardRef(CodeTwoTone);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/CodeTwoTone.js
// module id = 823
// module chunks = 0